import React, { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  className?: string;
}

export const SinglePrice: React.FC<Props> = ({ children, className }) => (
  <div className={`t-ellipsis ${className || ''}`}>{children}</div>
);
